(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  const overlay = document.querySelector('[data-cart-overlay]');
  const drawer = overlay?.querySelector('[data-cart-drawer]');
  if (!drawer || overlay.dataset.ldcViewportReady) return;
  overlay.dataset.ldcViewportReady = 'true';

  const root = document.documentElement;
  const viewport = window.visualViewport;
  let opened = false;
  let savedPosition = { x: 0, y: 0 };
  let pendingPosition = null;
  let frame = 0;

  const updateViewport = () => {
    frame = 0;
    if (!opened) return;
    const height = Math.max(1, Math.floor(viewport?.height || window.innerHeight));
    const top = Math.max(0, viewport?.offsetTop || 0);
    overlay.style.setProperty('--ldc-cart-height', `${height}px`);
    overlay.style.setProperty('--ldc-cart-top', `${top}px`);
  };

  const queueViewport = () => {
    if (opened && !frame) frame = requestAnimationFrame(updateViewport);
  };

  const rememberPosition = event => {
    if (opened || !event.target.closest?.('[data-cart-drawer-open], [data-product-atc]')) return;
    pendingPosition = { x: window.scrollX, y: window.scrollY, time: performance.now() };
  };

  const sync = () => {
    const active = overlay.classList.contains('active');
    if (active && !opened) {
      savedPosition = pendingPosition && performance.now() - pendingPosition.time < 2000
        ? pendingPosition
        : { x: window.scrollX, y: window.scrollY };
      pendingPosition = null;
      opened = true;
      root.style.setProperty('--ldc-cart-page-top', `${-savedPosition.y}px`);
      root.classList.add('ldc-cart-open');
      drawer.classList.add('allow-scroll-while-locked');
      drawer.scrollTop = 0;
      updateViewport();
      queueViewport();
    } else if (!active && opened) {
      opened = false;
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      root.classList.add('ldc-cart-restoring');
      root.classList.remove('ldc-cart-open');
      root.style.removeProperty('--ldc-cart-page-top');
      window.scrollTo({ left: savedPosition.x, top: savedPosition.y, behavior: 'instant' });
      requestAnimationFrame(() => root.classList.remove('ldc-cart-restoring'));
    }
  };

  document.addEventListener('pointerdown', rememberPosition, { capture: true, passive: true });
  new MutationObserver(sync).observe(overlay, { attributes: true, attributeFilter: ['class'] });
  viewport?.addEventListener('resize', queueViewport, { passive: true });
  viewport?.addEventListener('scroll', queueViewport, { passive: true });
  window.addEventListener('resize', queueViewport, { passive: true });
  window.addEventListener('pageshow', () => { sync(); queueViewport(); });
  sync();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ldc-choice-finder"] && !Shopify.designMode) return;
  try {
    function ldcFinderColourCode(value) {
  const match=String(value||'').trim().match(/^#?(\d+[a-z]*(?:\/\d+[a-z]*)?)(?=\s|[.(—–-]|$)/i);
  return match?match[1].toLowerCase():'';
}
function ldcFinderAvailableColours(records, texture, method) {
  const colours=new Set();
  for(const record of records){
    if(texture&&!record.textures.includes(texture))continue;
    if(method&&!record.methods.includes(method))continue;
    for(const raw of record.colors){const code=ldcFinderColourCode(raw);if(code)colours.add(code);}
  }
  return Array.from(colours).sort((a,b)=>a.localeCompare(b,undefined,{numeric:true}));
}


  const ldcFinderCatalogueRequests = new Map();
  const ldcFinderSwatches = {
    '1': '#141212', '8a': '#9b9184', '1b': '#211b18', '2': '#35251e', '3': '#493124', '4': '#60402c',
    '5': '#805832', '6': '#966b40', '18': '#a88752', '22': '#c2a16a',
    '24': '#d6bb82', '27': '#bd8744', '33b': '#74392b', '613': '#f0dfa9', '60ash': '#d9d6ce',
    '6/613': 'linear-gradient(180deg,#966b40 0%,#966b40 28%,#c3a671 58%,#f0dfa9 82%,#f0dfa9 100%)'
  };

  function ldcFinderCatalogue(allUrl) {
    const endpoint = new URL(allUrl, window.location.origin);
    const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewTheme) endpoint.searchParams.set('preview_theme_id', previewTheme);
    endpoint.searchParams.set('section_id', 'ldc-finder-catalogue');
    const key = endpoint.href;
    if (ldcFinderCatalogueRequests.has(key)) return ldcFinderCatalogueRequests.get(key);
    const request = (async () => {
      const records = [];
      let pages = 1;
      for (let page = 1; page <= pages; page++) {
        endpoint.searchParams.set('page', String(page));
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch(endpoint.href, {
            credentials: 'same-origin', cache: 'no-store', signal: controller.signal
          });
          if (!response.ok) throw new Error('Catalogue unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const payload = html.querySelector('[data-ldc-finder-catalogue]');
          if (!payload) throw new Error('Catalogue section missing');
          const data = JSON.parse(payload.textContent);
          if (data.page !== page || !Number.isInteger(data.pages) || data.pages < 0 ||
              !Array.isArray(data.records) || !data.records.every(record =>
                record && ['textures', 'methods', 'colors'].every(name =>
                  Array.isArray(record[name]) && record[name].every(value => typeof value === 'string')))) {
            throw new Error('Invalid catalogue response');
          }
          if (page === 1) pages = Math.max(1, data.pages);
          records.push(...data.records);
        } finally {
          clearTimeout(timeout);
        }
      }
      return records;
    })();
    ldcFinderCatalogueRequests.set(key, request);
    request.catch(() => ldcFinderCatalogueRequests.delete(key));
    return request;
  }

  function ldcInitFinders(root = document) {
    root.querySelectorAll('[data-ldc-finder]').forEach(finder => {
      if (finder.dataset.ready) return;
      const config = JSON.parse(finder.querySelector('[data-finder-config]').textContent);
      const form = finder.querySelector('form');
      const guide = finder.closest('.ldc-choice-guide');
      const contact = guide?.querySelector('a[href^="https://wa.me/"]');
      const colour = form.elements.color;
      const picker = finder.querySelector('[data-colour-picker]');
      const summary = picker.querySelector('summary');
      const selectedLabel = picker.querySelector('[data-colour-value]');
      const selectedSwatch = picker.querySelector('[data-colour-swatch]');
      const options = picker.querySelector('[data-colour-options]');
      const status = finder.querySelector('[data-colour-status]');
      const retry = finder.querySelector('[data-colour-retry]');
      const submit = finder.querySelector('[type="submit"]');
      let catalogue = null;
      let loading = false;
      const colourDescription = code => config.colourLabels[code] || (code.includes('/') ? 'Ombré ' + code.split('/').map(part => config.colourLabels[part] || '#' + part.toUpperCase()).join(' / ') : '');
      const colourText = code => code ? '#' + code.toUpperCase() + (colourDescription(code) ? ' — ' + colourDescription(code) : '') : config.undecided;
      const colourSwatch = code => {
        if (ldcFinderSwatches[code]) return ldcFinderSwatches[code];
        const parts = code.split('/').map(part => ldcFinderSwatches[part]);
        return parts.length === 2 && parts.every(Boolean) ? 'linear-gradient(180deg,' + parts[0] + ' 0%,' + parts[0] + ' 28%,' + parts[1] + ' 82%,' + parts[1] + ' 100%)' : '';
      };
      const selectedText = name => form.elements[name].selectedOptions[0]?.textContent || config.undecided;
      const updateContact = () => {
        if (!contact) return;
        const labels = ['texture', 'method'].filter(name => form.elements[name].value).map(selectedText);
        const message = config.message
          .replace('{choice}', labels.join(' · ') || config.all)
          .replace('{color}', selectedText('color'))
          .replace('{goal}', selectedText('goal'));
        contact.href = 'https://wa.me/351965319055?text=' + encodeURIComponent(message);
      };
      const updateSelected = () => {
        selectedLabel.textContent = colourText(colour.value);
        selectedSwatch.style.background = colourSwatch(colour.value);
        options.querySelectorAll('button').forEach(button => {
          button.setAttribute('aria-pressed', String(button.value === colour.value));
        });
      };
      const setDisabled = disabled => {
        colour.disabled = disabled;
        summary.setAttribute('aria-disabled', String(disabled));
        summary.tabIndex = disabled ? -1 : 0;
        if (disabled) picker.open = false;
      };
      const closePicker = () => { picker.open = false; summary.focus(); };
      const choose = code => {
        if (colour.disabled) return;
        colour.value = code;
        updateSelected();
        colour.dispatchEvent(new Event('change', { bubbles: true }));
      };
      const renderOptions = codes => {
        // Keep a real select as the source for navigation and the WhatsApp message.
        colour.replaceChildren();
        options.querySelectorAll('button').forEach(button => button.remove());
        for (const code of ['', ...codes]) {
          const text = colourText(code);
          const nativeOption = document.createElement('option');
          nativeOption.value = code;
          nativeOption.textContent = text;
          colour.append(nativeOption);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ldc-colour-picker__option';
          button.value = code;
          button.setAttribute('aria-pressed', 'false');
          const swatch = document.createElement('span');
          swatch.className = 'ldc-colour-swatch';
          swatch.setAttribute('aria-hidden', 'true');
          swatch.style.background = colourSwatch(code);
          const description = document.createElement('span');
          description.textContent = text;
          const check = document.createElement('span');
          check.className = 'ldc-colour-picker__check';
          check.textContent = '✓';
          check.setAttribute('aria-hidden', 'true');
          button.append(swatch, description, check);
          button.addEventListener('click', () => {
            choose(code);
            closePicker();
          });
          options.append(button);
        }
      };
      const refreshColours = () => {
        if (!catalogue) return;
        const before = colour.value;
        const codes = ldcFinderAvailableColours(catalogue, form.elements.texture.value, form.elements.method.value);
        renderOptions(codes);
        colour.value = codes.includes(before) ? before : '';
        setDisabled(codes.length === 0);
        submit.disabled = codes.length === 0;
        updateSelected();
        status.textContent = !codes.length ? config.colourMessages.empty
          : before && !colour.value ? config.colourMessages.reset : config.colourMessages.available;
        updateContact();
      };
      const loadColours = async () => {
        if (loading) return;
        loading = true;
        retry.hidden = true;
        picker.setAttribute('aria-busy', 'true');
        setDisabled(true);
        status.textContent = config.colourMessages.loading;
        try {
          const records = await ldcFinderCatalogue(config.allUrl);
          if (!finder.isConnected) return;
          catalogue = records;
          refreshColours();
        } catch (error) {
          if (!finder.isConnected) return;
          colour.value = '';
          updateSelected();
          updateContact();
          setDisabled(true);
          submit.disabled = false;
          status.textContent = config.colourMessages.error;
          retry.hidden = false;
        } finally {
          loading = false;
          picker.setAttribute('aria-busy', 'false');
        }
      };
      summary.addEventListener('click', event => { if (colour.disabled) event.preventDefault(); });
      finder.querySelector('label[for="' + colour.id + '"]').addEventListener('click', event => {
        event.preventDefault();
        if (!colour.disabled) { picker.open = true; summary.focus(); }
      });
      picker.addEventListener('toggle', () => {
        if (!picker.open) return;
        if (colour.disabled) { picker.open = false; return; }
        options.querySelector('button[aria-pressed="true"]')?.focus({ preventScroll: true });
      });
      picker.addEventListener('keydown', event => {
        if (picker.open && event.key === 'Escape') {
          event.preventDefault();
          closePicker();
        }
      });
      picker.addEventListener('focusout', () => {
        window.setTimeout(() => { if (!picker.contains(document.activeElement)) picker.open = false; }, 0);
      });
      retry.addEventListener('click', loadColours);
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (submit.disabled) return;
        const texture = config.textures[form.elements.texture.value];
        const method = config.methods[form.elements.method.value];
        let path = method?.url || texture?.url || config.allUrl;
        if (method && texture) path = path.replace(/\/$/, '') + '/' + texture.tag;
        const destination = new URL(path, window.location.origin);
        if (colour.value) destination.searchParams.set('ldc_color', colour.value);
        const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewTheme) destination.searchParams.set('preview_theme_id', previewTheme);
        destination.hash = 'ldc-collection-results';
        window.location.assign(destination.href);
      });
      form.addEventListener('change', event => {
        if (event.target === form.elements.texture || event.target === form.elements.method) refreshColours();
        updateContact();
      });
      updateContact();
      finder.dataset.ready = 'true';
      finder.hidden = false;
      guide?.classList.add('ldc-choice-guide--interactive');
      loadColours();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => ldcInitFinders());
  else ldcInitFinders();
  document.addEventListener('shopify:section:load', event => ldcInitFinders(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ldc-collection-filters"] && !Shopify.designMode) return;
  try {
    function ldcInitCatalogueFilters(root = document) {
    for (const form of root.querySelectorAll('[data-ldc-catalogue-filters]')) {
      if (form.dataset.ready) continue;
      const current = new URL(form.dataset.baseUrl, window.location.origin);
      const basePath = current.pathname.replace(/\/$/, '');
      const path = window.location.pathname.replace(/\/$/, '');
      const selectedTags = path.startsWith(basePath + '/') ? path.slice(basePath.length + 1).split('+').map(decodeURIComponent).filter(Boolean) : [];
      const knownTags = new Set();
      const context = { texture: form.dataset.collectionTexture, method: form.dataset.collectionMethod };
      for (const name of ['texture', 'method']) {
        const select = form.elements[name];
        const options = Array.from(select.options);
        options.forEach(option => { if (option.value) knownTags.add(option.value); });
        const explicit = options.find(option => option.value && selectedTags.includes(option.value));
        select.value = explicit ? explicit.value : context[name] || select.value;
      }
      const preservedTags = selectedTags.filter(tag => !knownTags.has(tag));
      const matchesContext = () => ['texture', 'method'].every(name => !context[name] || form.elements[name].value === context[name]);
      const destinationForSelection = () => {
        let baseUrl = form.dataset.baseUrl;
        if (!matchesContext()) {
          baseUrl = form.elements.method.selectedOptions[0]?.dataset.collectionUrl || form.elements.texture.selectedOptions[0]?.dataset.collectionUrl || form.dataset.allUrl;
        }
        const destination = new URL(baseUrl, window.location.origin);
        const tags = [...preservedTags, form.elements.texture.value, form.elements.method.value].filter(Boolean);
        if (tags.length) destination.pathname = destination.pathname.replace(/\/$/, '') + '/' + [...new Set(tags)].join('+');
        destination.search = window.location.search;
        destination.searchParams.delete('page');
        return destination;
      };
      if (!matchesContext()) {
        window.location.replace(destinationForSelection().href);
        return;
      }
      const clearSelection = form.querySelector('[data-ldc-clear-selection]');
      if (clearSelection) clearSelection.hidden = !selectedTags.length && !context.texture && !context.method;
      form.addEventListener('submit', event => {
        event.preventDefault();
        window.location.assign(destinationForSelection().href);
      });
      form.dataset.ready = 'true';
      form.hidden = false;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => ldcInitCatalogueFilters());
  else ldcInitCatalogueFilters();
  document.addEventListener('shopify:section:load', event => ldcInitCatalogueFilters(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ldc-klarna-quantity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ldc-klarna-quantity')) {
    customElements.define('ldc-klarna-quantity', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('[data-product-details], [data-ldc-color-product]');
        if (!this.root) return;
        try { this.prices = JSON.parse(this.querySelector('script').textContent); }
        catch (error) { return; }

        this.schedule = () => {
          clearTimeout(this.updateTimer);
          // Retina's +/- controls change the input value without dispatching change.
          this.updateTimer = setTimeout(() => this.sync(), 0);
        };
        this.scheduleSelection = () => {
          this.schedule();
          this.settleTimers?.forEach(clearTimeout);
          this.settleTimers = [250, 1000, 2000].map((delay) => setTimeout(() => {
            if (!this.isConnected) return;
            this.sync();
            this.refresh();
          }, delay));
        };
        this.onInput = (event) => {
          if (event.target.matches('[name="quantity"], [name="id"]')) this.scheduleSelection();
        };
        this.onClick = (event) => {
          if (event.target.closest('[data-quantity-plus], [data-quantity-minus]')) this.scheduleSelection();
        };
        this.root.addEventListener('input', this.onInput);
        this.root.addEventListener('change', this.onInput);
        this.root.addEventListener('click', this.onClick);
        this.root.addEventListener('variant-change', this.scheduleSelection, true);
        window.addEventListener('pageshow', this.scheduleSelection);
        window.addEventListener('popstate', this.scheduleSelection);

        // Also catches a late app placement or an app resetting the amount to one unit.
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.root, {
          subtree: true, childList: true, attributes: true,
          attributeFilter: ['data-payment-amount', 'data-purchase-amount', 'variant']
        });
        customElements.whenDefined('klarna-placement').then(() => {
          if (this.isConnected) { this.sync(); this.refresh(); }
        });
        this.sync();
      }

      sync() {
        if (!this.isConnected) return;
        const colorVariant = this.root.querySelector('[data-color-variant]');
        const selection = this.root.querySelector('variant-selection');
        const variantId = colorVariant ? colorVariant.value : selection
          ? (selection.getAttribute('variant') || this.root.querySelector('[name="id"]')?.value || this.dataset.initialVariant) : (this.root.querySelector('[name="id"]')?.value || this.dataset.initialVariant);
        const price = this.prices[variantId];
        const input = this.root.querySelector('input[name="quantity"]');
        const quantity = input ? Number(input.value) : 1;
        const amount = price * quantity;
        if (!Number.isSafeInteger(price) || price < 0 || !Number.isSafeInteger(quantity)
          || quantity < 1 || !Number.isSafeInteger(amount)) return;
        let changed = false;
        this.root.querySelectorAll('klarna-placement').forEach((placement) => {
          ['data-payment-amount', 'data-purchase-amount'].forEach((attribute) => {
            if (placement.getAttribute(attribute) === String(amount)) return;
            placement.setAttribute(attribute, String(amount));
            changed = true;
          });
        });
        const selectionChanged = this.lastAmount !== amount || this.lastVariantId !== variantId;
        this.lastAmount = amount;
        if (selectionChanged) this.root.dispatchEvent(new CustomEvent('ldc:payment-amount', { detail: { amount }, bubbles: false }));
        this.lastVariantId = variantId;
        if (changed || selectionChanged) this.refresh();
      }

      refresh() {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => {
          if (!this.isConnected) return;
          try {
            if (typeof window.KOSMApp?.updatePurchaseAmount === 'function'
              && Number.isSafeInteger(this.lastAmount)) {
              window.KOSMApp.updatePurchaseAmount(this.lastAmount);
            }
            if (typeof window.KlarnaOnsiteService?.refresh === 'function') {
              window.KlarnaOnsiteService.refresh();
            } else if (typeof window.OnsiteMessaging?.refresh === 'function') {
              window.OnsiteMessaging.refresh();

            } else {
              window.Klarna?.OnsiteMessaging?.refresh?.();
            }
          } catch (error) {}
        }, 60);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.settleTimers?.forEach(clearTimeout);
        clearTimeout(this.updateTimer);
        clearTimeout(this.refreshTimer);
        if (!this.root) return;
        this.root.removeEventListener('input', this.onInput);
        this.root.removeEventListener('change', this.onInput);
        this.root.removeEventListener('click', this.onClick);
        this.root.removeEventListener('variant-change', this.scheduleSelection, true);
        window.removeEventListener('pageshow', this.scheduleSelection);
        window.removeEventListener('popstate', this.scheduleSelection);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ldc-product-price-unit"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant-change', (event) => {
    const details = event.target.closest('[data-product-details]');
    if (!details) return;
    const id = event.detail?.variant?.id;
    details.querySelectorAll('[data-ldc-unit-variant]').forEach((unit) => {
      unit.hidden = !id || unit.dataset.ldcUnitVariant !== String(id);
    });
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ldc-scalapay-message"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ldc-scalapay-message')){
  customElements.define('ldc-scalapay-message',class extends HTMLElement{
    connectedCallback(){
      this.root=this.closest('[data-product-details], [data-ldc-color-product]');
      this.updateAmount(Number(this.dataset.amount));
      this.onAmount=(event)=>this.updateAmount(event.detail.amount);
      this.root?.addEventListener('ldc:payment-amount',this.onAmount);
      this.position=()=>{
        if(!this.isConnected||!this.root)return;
        const placement=this.root.querySelector('klarna-placement');
        const anchor=placement?.closest('.product-app')||placement?.closest('.shopify-block')||placement;
        if(anchor&&anchor.nextElementSibling!==this)anchor.insertAdjacentElement('afterend',this);
        const sync=this.root.querySelector('ldc-klarna-quantity');
        if(Number.isSafeInteger(sync?.lastAmount))this.updateAmount(sync.lastAmount);
      };
      this.observer=new MutationObserver(this.position);
      if(this.root)this.observer.observe(this.root,{subtree:true,childList:true});
      this.position();
    }
    updateAmount(amount){
      if(!Number.isSafeInteger(amount))return;
      const showSimulation=amount>=500&&amount<=499999;
      this.hidden=false;
      const simulation=this.querySelector('[data-scalapay-simulation]');
      const generic=this.querySelector('[data-scalapay-generic]');
      if(simulation)simulation.hidden=!showSimulation;
      if(generic)generic.hidden=showSimulation;
      this.dataset.amount=String(amount);
      const target=this.querySelector('[data-scalapay-amount]');
      const formatted=new Intl.NumberFormat(this.dataset.locale||'pt-PT',{style:'currency',currency:'EUR'}).format(Math.round(amount/4)/100);
      if(target&&target.textContent!==formatted)target.textContent=formatted;
    }
    disconnectedCallback(){this.observer?.disconnect();this.root?.removeEventListener('ldc:payment-amount',this.onAmount);}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ldc-transformation-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ldc-case-video')) {
    customElements.define('ldc-case-video', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const details = this.querySelector('details');
        details?.addEventListener('toggle', () => {
          if (!details.open) this.querySelector('video')?.pause();
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  if (!customElements.get('ldc-before-after')) {
    customElements.define('ldc-before-after', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const input = this.querySelector('input[type="range"]');
        const control = this.querySelector('.ldc-compare__control');
        if (!input || !control) return;
        const update = () => {
          const value = Math.min(100, Math.max(0, Number(input.value)));
          this.style.setProperty('--comparison', `${value}%`);
          input.setAttribute('aria-valuetext', (this.dataset.valueTemplate || '').replace('__value__', String(value)));
        };
        input.addEventListener('input', update, { signal: this.controller.signal });
        control.hidden = false;
        update();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl);
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // Always hide loading state
        this.hideLoadingState();
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus();
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.gift-recipient"] && !Shopify.designMode) return;
  try {
    class GiftRecipientForm extends HTMLElement {
    constructor() {
      super()
      this.checkboxInput = this.querySelector('.gift-recipient-form__checkbox input[type="checkbox"]')
      this.emailInput = this.querySelector('.gift-recipient-form__email')
      this.nameInput = this.querySelector('.gift-recipient-form__name')
      this.messageInput = this.querySelector('.gift-recipient-form__message')
      this.dateInput = this.querySelector('.gift-recipient-form__date')
      this.addEventListener('change', () => this.onChange())
      this.recipientFields = this.querySelector('.recipient-fields')

      this.checkboxInput.addEventListener('change', () => {
        event.stopPropagation()
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none'
      })
    }

    connectedCallback() {
      this.abortController = new AbortController()

      document.addEventListener('product-form:submit:error', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.displayErrorMessage(event.detail.errorMessage)
        }
      }, { signal: this.abortController.signal })

      document.addEventListener('product-form:submit:success', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.clearInputFields()
          this.clearErrorMessage()
        }
      }, { signal: this.abortController.signal })
    }

    disconnectedCallback() {
      this.abortController.abort()
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields()
        this.clearErrorMessage()
      }
    }

    clearInputFields() {
      for (const element of this.querySelectorAll('input')) {
        element.value = ''
      }
    }

    displayErrorMessage(body) {
      this.clearErrorMessage()
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`]
          if (!inputElement) {
            return
          }

          inputElement.setAttribute('aria-invalid', true)
        })
      }
    }

    clearErrorMessage() {
      for (const inputElement of this.querySelectorAll('input')) {
        inputElement.setAttribute('aria-invalid', false)
        inputElement.removeAttribute('aria-describedby')
      }
    }
  }

  customElements.define('gift-recipient-form', GiftRecipientForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryElement extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.media-gallery__slide');
      this.thumbs = this.querySelectorAll('.media-gallery__thumb');
      this.prevBtn = this.querySelector('.media-gallery__nav--prev');
      this.nextBtn = this.querySelector('.media-gallery__nav--next');
      this.mainContainer = this.querySelector('.media-gallery__main');
      this.currentIndex = 0;
      this.isAnimating = false;
      this.isNaturalAspectRatio = this.mainContainer?.getAttribute('data-aspect-ratio') === 'initial';

      // Touch/swipe handling
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.minSwipeDistance = 50;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Adjust container height for natural aspect ratio
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight(true); // Disable transition for initial setup

        // Set up resize observer for images that might load asynchronously
        this.setupResizeObserver();
      }

      // Add click handlers to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const direction = index > this.currentIndex ? 'next' : 'prev';
          this.goToSlide(index, direction);
        });
      });

      // Add click handlers to navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.previousSlide();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.nextSlide();
        });
      }

      // Add keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      });

      // Make the gallery focusable for keyboard navigation
      this.setAttribute('tabindex', '0');

      // Add touch/swipe handlers
      this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
      this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });

      // Ensure only the initial active slide can play
      this.pauseNonActiveSlides();
      this.autoplayActiveSlideIfEligible();
    }

    goToSlide(index, direction = 'next') {
      if (index < 0 || index >= this.slides.length) return;
      if (index === this.currentIndex) return;
      if (this.isAnimating) return;

      const currentSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[index];

      // Before animating, pause non-target slides
      this.pauseAllMediaExceptInSlide(targetSlide);

      // Reset all slides
      this.resetSlides();

      // Position slides for animation
      this.positionSlidesForAnimation(currentSlide, targetSlide, direction);

      // Update UI state
      this.updateThumbnails(index);
      this.currentIndex = index;

      // Start animation after positioning is applied
      this.animateSlides(currentSlide, targetSlide, direction);

      // Adjust container height for natural aspect ratio after slide change
      if (this.isNaturalAspectRatio) {
        setTimeout(() => {
          this.adjustContainerHeight();
        }, 50); // Small delay to ensure slide is positioned
      }
    }

    resetSlides() {
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next');
      });
    }

    positionSlidesForAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class from all slides during positioning
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--is-animating');
      });

      if (direction === 'next') {
        // Next: target and others on right, current stays in center
        targetSlide.style.transform = 'translateX(100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(100%)';
          }
        });
      } else {
        // Previous: target and others on left, current stays in center
        targetSlide.style.transform = 'translateX(-100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(-100%)';
          }
        });
      }
    }

    updateThumbnails(activeIndex) {
      this.thumbs[this.currentIndex].classList.remove('media-gallery__thumb--active');
      this.thumbs[activeIndex].classList.add('media-gallery__thumb--active');
    }

    adjustContainerHeight(disableTransition = false) {
      if (!this.isNaturalAspectRatio || !this.mainContainer) return;

      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      // Disable transition if requested (for initial setup)
      if (disableTransition) {
        this.mainContainer.classList.add('media-gallery__main--no-transition');
      }

      // Find the image in the active slide
      const img = activeSlide.querySelector('img');
      if (!img) return;

      // Get the image's natural dimensions
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;

      if (imgWidth && imgHeight) {
        // Calculate the aspect ratio
        const aspectRatio = imgWidth / imgHeight;

        // Get the container width
        const containerWidth = this.mainContainer.offsetWidth;

        // Calculate the height based on the aspect ratio
        const calculatedHeight = containerWidth / aspectRatio;

        // Set the container height
        this.mainContainer.style.height = calculatedHeight + 'px';
      } else {
        // Fallback: temporarily make the slide visible to measure its height
        const originalOpacity = activeSlide.style.opacity;
        const originalTransform = activeSlide.style.transform;
        activeSlide.style.opacity = '1';
        activeSlide.style.transform = 'translateX(0)';
        activeSlide.style.position = 'relative';
        activeSlide.style.visibility = 'hidden';

        // Get the natural height of the slide content
        const slideHeight = activeSlide.offsetHeight;

        // Restore original styles
        activeSlide.style.opacity = originalOpacity;
        activeSlide.style.transform = originalTransform;
        activeSlide.style.position = '';
        activeSlide.style.visibility = '';

        // Set the container height to match the slide height
        this.mainContainer.style.height = slideHeight + 'px';
      }

      // Re-enable transition after a brief delay
      if (disableTransition) {
        setTimeout(() => {
          this.mainContainer.classList.remove('media-gallery__main--no-transition');
        }, 10);
      }
    }

    setupResizeObserver() {
      if (!this.isNaturalAspectRatio || !window.ResizeObserver) return;

      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContainerHeight();
      });

      // Observe all images in the slides
      this.slides.forEach(slide => {
        const images = slide.querySelectorAll('img');
        images.forEach(img => {
          this.resizeObserver.observe(img);

          // Also listen for load events to recalculate when image loads
          img.addEventListener('load', () => {
            if (slide.classList.contains('media-gallery__slide--active')) {
              this.adjustContainerHeight();
            }
          });
        });
      });
    }

    animateSlides(currentSlide, targetSlide, direction) {
      // Set animation flag
      this.isAnimating = true;

      // Frame 1: Initial positions are already set (no animation class)

      // Frame 2: Add animation class
      requestAnimationFrame(() => {
        currentSlide.classList.add('media-gallery__slide--is-animating');
        targetSlide.classList.add('media-gallery__slide--is-animating');

        // Frame 3: Trigger animation
        requestAnimationFrame(() => {
          // Animate current slide out
          if (direction === 'next') {
            currentSlide.style.transform = 'translateX(-100%)';
          } else {
            currentSlide.style.transform = 'translateX(100%)';
          }

          // Animate target slide in
          targetSlide.style.transform = 'translateX(0)';
          targetSlide.classList.add('media-gallery__slide--active');

          // Clean up after animation
          this.waitForTransition(currentSlide).then(() => {
            this.positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction);
            this.scrollActiveThumbnailIntoView();
            // Hydrate and autoplay current slide media if eligible and pause others
            this.pauseNonActiveSlides();
            this.autoplayActiveSlideIfEligible();
            // Clear animation flag
            this.isAnimating = false;
          });
        });
      });
    }

    positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class and active class from current slide
      currentSlide.classList.remove('media-gallery__slide--is-animating', 'media-gallery__slide--active');
      targetSlide.classList.remove('media-gallery__slide--is-animating');

      if (direction === 'next') {
        currentSlide.style.transform = 'translateX(100%)';
      } else {
        currentSlide.style.transform = 'translateX(-100%)';
      }

      // Adjust container height for natural aspect ratio after animation
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight();
      }
    }

    scrollActiveThumbnailIntoView() {
      this.thumbs[this.currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex, 'next');
    }

    previousSlide() {
      const prevIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goToSlide(prevIndex, 'prev');
    }

    waitForTransition(element) {
      return new Promise((resolve) => {
        const handleTransitionEnd = (e) => {
          if (e.target === element) {
            element.removeEventListener('transitionend', handleTransitionEnd);
            resolve();
          }
        };
        element.addEventListener('transitionend', handleTransitionEnd);
      });
    }

    handleTouchStart(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    }

    handleTouchMove(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchEnd(e) {
      if (this.isAnimating) return;

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // Only trigger swipe if horizontal movement is greater than vertical
      if (absDeltaX > absDeltaY && absDeltaX > this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous slide
          this.previousSlide();
        } else {
          // Swipe left - go to next slide
          this.nextSlide();
        }
      }
    }

    // Utilities for media control
    pauseAllMediaExceptInSlide(slide) {
      const allowed = new Set(slide ? Array.from(slide.querySelectorAll('video-media, model-media')) : []);
      this.querySelectorAll('video-media[playing], model-media[playing]').forEach((el) => {
        if (!allowed.has(el)) {
          el.pause();
        }
      });
    }

    pauseNonActiveSlides() {
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.querySelectorAll('video-media[playing], model-media[playing]').forEach((element) => element.pause());
        }
      });
    }

    autoplayActiveSlideIfEligible() {
      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      const mediaEls = activeSlide.querySelectorAll('video-media, model-media');
      mediaEls.forEach((element) => {
        if (!element.hasAttribute('autoplay')) return;
        if (element.hasAttribute('playing')) return;
        // If already loaded, try immediately; else wait for 'loaded' attribute
        if (element.hasAttribute('loaded')) {
          element.play();
        } else {
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'loaded' && element.hasAttribute('loaded')) {
                observer.disconnect();
                element.play();
                break;
              }
            }
          });

          observer.observe(element, { attributes: true, attributeFilter: ['loaded'] });
        }
      });
    }
  }

  // Define the custom element
  customElements.define('media-gallery', MediaGalleryElement);
  } catch(e) { console.error(e); }
})();

})();
